<template>
    <section>
        <form @submit.prevent="next()" novalidate>
        <div class="t-headline5 mt3">
            {{$t('1646')}}
            <!-- 개인정보 입력 -->
        </div>
        <div class="t-body3 mt6 t-color-content1">
            {{$t('1647')}}
            <!-- 비밀번호를 설정하세요. -->
        </div>
        <div class="mt38">
            
            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                :class="submitState && passwordInvalidCheck ? 'mdc-text-field--invalid' : ''"
                id="passwordEl"
            >
                <i class="material-icons mdc-text-field__icon">
                    {{validIcon}}
                </i>
                <input type="password" class="mdc-text-field__input"
                    v-model="password"
                    v-validate="'required|min:10|verify_password'"
                    ref="password"
                    id="password"
                    name="password"
                    maxlength="50"
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                        {{$t('1648')}}
                        <!-- 비밀번호 -->
                    </label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
                
            </div>
            <div class="t-helper text-helper " :class="submitState && passwordInvalidCheck ? 'warning' : ''">
                <span>{{$t('1649')}}</span>
            </div>
        </div>
        <div class="mt26 mb19">
            <button class="mdc-button mdc-button--raised btn-red mr8">
                {{$t('1650')}}
                <!-- 다음 -->
            </button>
            <button class="mdc-button btn-white" @click="cancelJoin()" type="button">
                {{$t('1651')}}
                <!-- 취소 -->
            </button>
        </div>

        
        </form>
    </section>
    
</template>

<script>
/**
 * 아이디 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'

// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            password: '',
            passwordTextField: null,
            submitState: false,
            validIcon: ''
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // email 유효성 Check 및 아이콘
        passwordInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('password')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = 'check'
                }
            }

            this.passwordTextField.valid === !returnValue ? '' : this.passwordTextField.valid = !returnValue
            return returnValue
        }

    },

    created() {
        if (
                !this.join.role || !this.join.responsibility || 
                !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || 
                !this.join.name.last || !this.join.loginId
            ) {
            //this.$router.go(-1)
        }
    },

    mounted() {
        this.setMaterialUi()
        // this.$refs.email.focus()
        this.$refs.password.focus()
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', ['SET_LOGINPW']),

        setMaterialUi() {
            this.passwordTextField = new MDCTextField(document.querySelector('#passwordEl'))
            this.passwordTextField.useNativeValidation = false
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })

            this.password = this.join.loginPw
            this.passwordTextField.value = this.password
        },

        next() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.SET_LOGINPW(this.password)
                    this.$router.push({name: 'JoinStore'})
                } else{
                    this.focusFirstInvalidElement()
                }
            })
        }
    },

    

}
</script>

<style scoped>

</style>
